/* ==========================================================================
   PRODUCT — galeri, varyant seçici, mobil sabit sepet çubuğu
   Yalnızca ürün sayfasında yüklenir.

   Varyant seçici JS olmadan da çalışır: <select name="id"> normal bir form
   alanı, script çalışmazsa müşteri varyantı seçip sepete ekleyebilir.
   Galeri de JS'siz çalışır — ana görsel HTML'de basılıdır.
   ========================================================================== */

(function () {
  'use strict';

  var theme = window.theme || {};

  /* ----------------------------------------------------------------- Galeri */

  function initGallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return;

    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function (e) {
        e.preventDefault();
        showMedia(this.getAttribute('data-media-id'));
      });
    }

    function showMedia(id) {
      var slides = main.querySelectorAll('[data-media-id]');
      for (var j = 0; j < slides.length; j++) {
        slides[j].classList.toggle('is-active', slides[j].getAttribute('data-media-id') === id);
      }
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].classList.toggle('is-active', thumbs[k].getAttribute('data-media-id') === id);
        thumbs[k].setAttribute('aria-current', thumbs[k].getAttribute('data-media-id') === id ? 'true' : 'false');
      }
    }

    /* Varyant değişince o varyantın görseline geç */
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var mediaId = e.detail.variant.featured_media ? e.detail.variant.featured_media.id : null;
      if (mediaId) showMedia(String(mediaId));
    });
  }

  /* --------------------------------------------------------- Varyant seçici */

  function initVariants() {
    var form = document.querySelector('[data-variant-form]');
    if (!form) return;

    var dataEl = document.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return; /* Bozuk JSON'da sessizce çık — select yine de çalışır */
    }

    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('[name="id"]');
    if (!selects.length || !idInput) return;

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', onChange);
    }

    function onChange() {
      var chosen = [];
      for (var j = 0; j < selects.length; j++) chosen.push(selects[j].value);

      var match = null;
      for (var k = 0; k < variants.length; k++) {
        if (sameOptions(variants[k].options, chosen)) {
          match = variants[k];
          break;
        }
      }

      var button = form.querySelector('[type="submit"]');
      var priceHolder = document.querySelector('[data-variant-price]');

      if (!match) {
        if (button) {
          button.disabled = true;
          button.textContent = theme.strings.sold_out;
        }
        return;
      }

      idInput.value = match.id;

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.getAttribute('data-label-add')
          : theme.strings.sold_out;
      }

      if (priceHolder && match.price != null) {
        priceHolder.innerHTML = renderPrice(match);
      }

      /* URL'i güncelle — sayfa paylaşılınca doğru varyant açılsın */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: match } }));
    }

    function sameOptions(a, b) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }

    function renderPrice(variant) {
      var html = '<span class="product__price">' + money(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <span class="product__compare"><s>' + money(variant.compare_at_price) + '</s></span>';
      }
      return html;
    }

    function money(cents) {
      var format = theme.moneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format
        .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withCommas);
    }
  }

  /* ------------------------------------------------- Mobil sabit sepet çubuğu
     Ana "Add to cart" butonu ekrandan çıkınca altta sabit bir çubuk görünür.
     Gözlemci yoksa çubuk hiç görünmez — sayfa yine tam çalışır. */

  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20% 0px' });

    observer.observe(anchor);
  }

  function init() {
    initGallery();
    initVariants();
    initStickyBar();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  document.addEventListener('shopify:section:load', init);
})();
